export const environment = {
  production: false,
  apiEndpoint: '%API_URL%',
  stripeKey:"%STRIPE_PUBLIC_KEY%"	
};
